import { Directive } from '@angular/core';

@Directive({
  selector: '[jbDialogTitle]',
})
export class DialogTitleDirective {}
